import { Group } from "@mantine/core"

import type { LibraryResponses } from "@tfg/types/endpoints/library"

import { CustomFieldMaterialsColumn } from "~/pages/Brand/Products/Details/CustomFieldGraph/CustomFieldMaterialsColumn"
import { CustomFieldTreeBranch } from "~/pages/Brand/Products/Details/CustomFieldGraph/CustomFieldTreeBranch"
import { HorizontalDivider } from "~/pages/Brand/Products/Details/CustomFieldGraph/Divider.tsx"
import type { CustomFieldTreeSectionProps } from "~/pages/Brand/Products/Details/CustomFieldGraph/custom-field-graph.types"
import {
  getCustomFieldDefinitionsForItem,
  getProductActivityIds,
} from "~/pages/Brand/Products/Details/CustomFieldGraph/custom-field-graph.utils"

type Props = CustomFieldTreeSectionProps & {
  readonly component: LibraryResponses.EnrichedComponent
}

export const CustomFieldComponentTree = ({
  product,
  component,
  getOperations,
  originCue,
}: Props) => {
  const productActivityIds = getProductActivityIds(product)

  return (
    <Group gap={0} align="flex-start" wrap="nowrap">
      <CustomFieldTreeBranch
        customFieldsDefs={getCustomFieldDefinitionsForItem(
          product,
          component.item,
          productActivityIds
        )}
        hideFirstDivider={true}
        item={component.item}
        operations={getOperations(component.item)}
        originCue={originCue}
      />
      {component.materials.length > 0 && <HorizontalDivider />}
      <CustomFieldMaterialsColumn
        materials={component.materials}
        product={product}
        productActivityIds={productActivityIds}
        getOperations={getOperations}
      />
    </Group>
  )
}
